import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Format an integer cents value as a USD currency string (e.g. 1250 → "$12.50"). */
export function formatCents(cents: number): string {
  return USDFormatter.format(cents / 100);
}

const USDFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});
